export const ADD_CHECKLISTS = 'ADD_CHECKLISTS'
export const ADD_CHECKLIST = 'ADD_CHECKLIST'
